<div class="item-flexbox" appNoDblClick (onClick)="itemClick()" (dblclick)="itemDblClick()">
  <div class="icon-wrapper pr-12">
    <mat-icon>{{ selected ? 'check_circle' : itemType === attachmentType.Url ? 'link' : 'description'}}</mat-icon>
  </div>
  <div class="details">
    <div *ngIf="itemType === attachmentType.File" class="h3">
      {{item.fileName}}
    </div>
    <div *ngIf="itemType === attachmentType.Url">
      <span class="h3 text-truncate">{{item.url.link}},
        {{item.url.dateAdded | dateFormat}}
      </span>
    </div>
    <div *ngIf="!editMode">
      <div *ngIf="(itemType === attachmentType.File) && showLastModifiedDate">
        <span class="secondary-text">
          {{item.fileSize | fileSize}}, {{item.lastModifiedDate | dateFormat}}
        </span>
      </div>
      <div *ngIf="(itemType === attachmentType.File) && (!showLastModifiedDate)">
        <span class="secondary-text">
          {{item.fileSize | fileSize}}
        </span>
      </div>
      <div *ngIf="itemType === attachmentType.Url" class="secondary-text">
        {{item.url.summary}}
      </div>
      <div style="padding-top:3px" *ngIf="itemType === attachmentType.File">
        <span class="secondary-text" *ngIf="path.length > 0">
          Directory: {{path.substring(0, path.length - 1)}}
        </span>
      </div>
      <div style="padding-top:3px" *ngIf="itemType === attachmentType.File">
        <span class="secondary-text">
          {{summary}}
        </span>
      </div>
      <div style="padding-top:3px">
        <span class="attachment-label">
          {{labels.join(', ')}}
        </span>
      </div>
    </div>
    <div *ngIf="editMode" class="w-100-p">
      <mat-form-field *ngIf="itemType === attachmentType.File" class="w-100-p">
        <mat-label>Summary</mat-label>
        <input id="summary" matInput #input class="form-control" name="summary" value="{{summary}}"
          (change)="onSummaryChange($event.target.value)">
      </mat-form-field>
      <mat-form-field class="w-100-p">
        <mat-label>Labels</mat-label>
        <mat-chip-grid #chipList aria-label="Labels">
          <mat-chip-row *ngFor="let label of labels" [selectable]="true" [removable]="true" (removed)="removeLabel(label)">
            {{label}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
          <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="remove" maxlength=20 (matChipInputTokenEnd)="addLabel($event)">
        </mat-chip-grid>
      </mat-form-field>
    </div>
  </div>

  <button *ngIf="editMode" mat-icon-button aria-label="Save" class="mat-icon-button" (click)="closeEdit()" matTooltip="Save">
    <mat-icon>done</mat-icon>
  </button>
  <div *ngIf="!editMode && showCasePrepUI && itemHasExportStatus" (click)="$event.stopPropagation()"
    (dblclick)="$event.stopPropagation()" class="icon-wrapper--case-prep"
    [matTooltip]="'Export to Case Preparation File ' + (casePrepExportSuccess ? 'succeeded' : 'failed')">
    <mat-icon [ngClass]="casePrepExportSuccess ? 'success' : 'error'">
      {{ casePrepExportSuccess ? 'cloud_done' : 'cloud_off'}}
    </mat-icon>
  </div>
  <button *ngIf="!editMode" mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More"
    class="mat-icon-button" (click)="$event.stopPropagation(); deselectOtherFiles()"
    (dblclick)="$event.stopPropagation()" matTooltip="More">
    <mat-icon>more_vert</mat-icon>
  </button>
</div>

<mat-menu #moreMenu="matMenu">
  <button mat-menu-item aria-label="View File" (click)="viewFile($event)"
    *ngIf='(showViewFileButton===true) && (itemType === attachmentType.File)'>
    <mat-icon>open_in_new</mat-icon>
    <span>View File</span>
  </button>
  <button mat-menu-item aria-label="Download File" (click)="downloadFile($event)"
    *ngIf="itemType === attachmentType.File">
    <mat-icon>cloud_download</mat-icon>
    <span>Download File</span>
  </button>
  <button mat-menu-item aria-label="View URL" (click)="viewFile($event)"
    *ngIf='(showViewFileButton===true) && (itemType === attachmentType.Url)'>
    <mat-icon>open_in_new</mat-icon>
    <span>View URL</span>
  </button>
  <button mat-menu-item aria-label="Edit URL" (click)="editUrl($event)" *ngIf='(itemType === attachmentType.Url)'>
    <mat-icon>edit</mat-icon>
    <span>Edit URL</span>
  </button>
  <div *ngIf="!readOnly">
    <mat-divider></mat-divider>
    <button *ngIf="itemType === attachmentType.File" mat-menu-item aria-label="Edit Summary and Labels"
      (click)="editLabels($event)">
      <mat-icon>edit</mat-icon>
      <span>Edit Labels and Summary</span>
    </button>
    <button *ngIf="itemType === attachmentType.Url" mat-menu-item aria-label="Edit Labels" (click)="editLabels($event)">
      <mat-icon>edit</mat-icon>
      <span>Edit Labels</span>
    </button>
    <mat-divider *ngIf="userCanDeleteAttachments"></mat-divider>
    <button
      mat-menu-item
      aria-label="Delete File"
      (click)="deleteFile($event)"
      *ngIf="userCanDeleteAttachments && itemType === attachmentType.File"
    >
      <mat-icon>delete</mat-icon>
      <span>Delete File</span>
    </button>
    <button
      mat-menu-item
      aria-label="Delete URL"
      (click)="deleteFile($event)"
      *ngIf="userCanDeleteAttachments && itemType === attachmentType.Url"
    >
      <mat-icon>delete</mat-icon>
      <span>Delete URL</span>
    </button>
  </div>
</mat-menu>
